var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-location"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    clipPath: "url(#clip-location)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location-2",
    "data-name": "Location",
    transform: "translate(7.15 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M13,15.4a2.693,2.693,0,0,0-2.7,2.69h0c0,2.02,2.7,5.01,2.7,5.01s2.7-2.99,2.7-5.01a2.693,2.693,0,0,0-2.69-2.7h0Zm0,3.66a.96.96,0,1,1,.96-.96A.96.96,0,0,1,13,19.06Z",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_3",
    "data-name": "Union 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M11.19,22.12a13.528,13.528,0,0,1,.6-2.55c0-.4.01-.81,0-1.21a.71.71,0,0,1-.14-.1A2.884,2.884,0,0,1,11,16.91a1.168,1.168,0,0,1,.74-1.46l.09-.27A1.273,1.273,0,0,1,14,14.73V1a1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V25a1,1,0,0,0,1,1H11.51a9.292,9.292,0,0,1-.32-3.88Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M11.14,24H2V2H12V14.85a1.262,1.262,0,0,1,2-.13V1a1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V25a1,1,0,0,0,1,1H11.51A5.773,5.773,0,0,1,11.14,24Z",
    fill: "#fc4848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 2.99,
    height: 2.99,
    rx: 0.5,
    transform: "translate(3.21 10.76)",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 1.79,
    height: 1.79,
    rx: 0.1,
    transform: "translate(3.81 11.36)",
    fill: "none",
    stroke: "#fc4848",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_626-2",
    "data-name": "Rectangle 626-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 2.99,
    height: 2.99,
    rx: 0.5,
    transform: "translate(3.21 2.86)",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 1.79,
    height: 1.79,
    rx: 0.1,
    transform: "translate(3.81 3.46)",
    fill: "none",
    stroke: "#fc4848",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_626-3",
    "data-name": "Rectangle 626-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 2.99,
    height: 2.99,
    rx: 0.5,
    transform: "translate(7.16 2.86)",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 1.79,
    height: 1.79,
    rx: 0.1,
    transform: "translate(7.76 3.46)",
    fill: "none",
    stroke: "#fc4848",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_626-4",
    "data-name": "Rectangle 626-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 2.99,
    height: 2.99,
    rx: 0.5,
    transform: "translate(7.16 6.81)",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 1.79,
    height: 1.79,
    rx: 0.1,
    transform: "translate(7.76 7.41)",
    fill: "none",
    stroke: "#fc4848",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_626-5",
    "data-name": "Rectangle 626-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 2.99,
    height: 2.99,
    rx: 0.5,
    transform: "translate(3.21 6.81)",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 1.79,
    height: 1.79,
    rx: 0.1,
    transform: "translate(3.81 7.41)",
    fill: "none",
    stroke: "#fc4848",
    strokeWidth: 1.2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 2,
    height: 3.74,
    transform: "translate(14 24) rotate(90)",
    fill: "#fc4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 2,
    height: 1.14,
    transform: "translate(12 13.69)",
    fill: "#fc4848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/location_red.61dcc61c2e660cd8721be43e4fd22dba.svg";
export { ForwardRef as ReactComponent };